module.exports = __webpack_public_path__ + "img/sdg_es_(3).c9a196ed.png";